import { render, staticRenderFns } from "./NvrChannelDrawer.vue?vue&type=template&id=260af972&scoped=true"
import script from "./NvrChannelDrawer.vue?vue&type=script&lang=js"
export * from "./NvrChannelDrawer.vue?vue&type=script&lang=js"
import style0 from "./NvrChannelDrawer.vue?vue&type=style&index=0&id=260af972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260af972",
  null
  
)

export default component.exports